import React, { useEffect, useState } from 'react';
var mammoth = require("mammoth/mammoth.browser");

function DocxViewer({ filePath, fileName }) {
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        const loadFile = async () => {
            if (filePath) {
                try {
                    const result = await convertDocxToHtml(filePath);
                    setHtmlContent(result);
                } catch (error) {
                    console.error('Error converting DOCX to HTML:', error);
                }
            }
        };

        loadFile();
    }, [filePath]);

    const convertDocxToHtml = (filePath) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const arrayBuffer = xhr.response;

                        mammoth.extractRawText({ arrayBuffer: arrayBuffer })
                            .then((result) => {
                                resolve(result.value);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    } else {
                        reject(new Error(`Failed to load file. Status: ${xhr.status}`));
                    }
                }
            };

            xhr.open('GET', filePath);
            xhr.responseType = 'arraybuffer';
            xhr.send();
        });
    };

    return (
        <div>
            {filePath && (
                <div style={{ marginTop: 10 }}>
                    <a href={filePath} download target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#007bff' }}>
                        ⬇️ Download Arquivo - {fileName}
                    </a>
                </div>
            )}
            {htmlContent && <div dangerouslySetInnerHTML={{ __html: htmlContent }} />}
        </div>
    );
}

export default DocxViewer;
